/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

